import { gql } from '@apollo/client';

import { Exact, ExportInput } from '@/graphql/contracts/_generated_/contracts';


export const UnexpectedErrorDetailsFragmentDoc = gql`
  fragment UnexpectedErrorDetails on UnexpectedError {
    errorMessage
  }
`;

export const CreateExportJobDocument = gql`
  mutation CreateExportJob($export: ExportInput!) {
    general {
      exportJobs {
        createExportJob(input: $export) {
          ... on ExportRequestReceipt {
            id
          }
          ... on UnexpectedError {
            ...UnexpectedErrorDetails
          }
        }
      }
    }
  }
  ${UnexpectedErrorDetailsFragmentDoc}
`;

export type CreateExportJobMutation = {
  __typename?: 'Mutation';
  general?: {
    __typename?: 'GeneralMutations';
    exportJobs?: {
      __typename?: 'ExportJobMutation';
      createExportJob?:
      | { __typename?: 'ExportRequestReceipt'; id: string }
      | { __typename?: 'FailedValidation' }
      | { __typename?: 'UnexpectedError'; errorMessage: string }
      | null;
    } | null;
  } | null;
};

export type CreateExportJobMutationVariables = Exact<{
  export: ExportInput;
}>;
